import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setForbidAds, selectForbidAds, selectIsAgeVerified } from "../routes/Ad/ad.ducks";

/**
 * Unified hook for age verification across the application
 * Handles both category/module-based and direct 18+ content checks
 */
export const useAgeVerification = ({
  module,
  category,
  modules = [],
  categories = [],
  is18Old
}) => {
  const [ageVerificationModal, setAgeVerificationModal] = useState(null);
  const forbiddAds = useSelector(selectForbidAds);
  const isAgeVerified = useSelector(selectIsAgeVerified);
  const dispatch = useDispatch();

  useEffect(() => {
    // Skip if data not ready
    if (!modules.length && !categories.length && is18Old === undefined) {
      return;
    }

    let shouldForbid = false;

    // Check if content is directly marked as 18+
    if (is18Old === true) {
      shouldForbid = true;
    }

    // Check if module is 18+
    if (module && modules.length > 0) {
      modules.forEach(mod => {
        if (mod.name === module && mod.is18Old) {
          shouldForbid = true;
        }
      });
    }

    // Check if category is 18+
    if (category && categories.length > 0) {
      categories.forEach(cat => {
        if (cat.route === category && cat.is18Old) {
          shouldForbid = true;
        }
      });
    }

    // Only update state if value changed (prevent infinite loops)
    if (ageVerificationModal !== shouldForbid) {
      setAgeVerificationModal(shouldForbid);
    }
    if (forbiddAds !== shouldForbid) {
      dispatch(setForbidAds(shouldForbid));
    }
  }, [module, category, modules, categories, is18Old]);

  const shouldShowModal = ageVerificationModal === true && isAgeVerified !== true;

  return {
    ageVerificationModal,
    shouldShowModal,
    isAgeVerified,
    forbiddAds
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useAgeVerification.ts